var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "user__initials" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: { hover: true }
            }
          ],
          staticClass: "logged-in-user mr-2",
          attrs: { title: _vm.userName },
          on: { click: _vm.showOffscreenMenu }
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm._f("textInitials")(_vm.userName)) + "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c("OffscreenMenu", {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.hideOffscreenMenu,
            expression: "hideOffscreenMenu"
          }
        ],
        attrs: { userName: _vm.userName, toggle: _vm.toggle }
      }),
      _vm._v(" "),
      _vm.toggle
        ? _c("div", { staticClass: "offscreen__menu__backdrop" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }